import { scaffolderPlugin } from "@backstage/plugin-scaffolder";
import { createScaffolderFieldExtension } from "@backstage/plugin-scaffolder-react";
import { EnvVarField, envVarValidation } from "./EnvVarField";

// @TODO: Fix the typing issues
export const EnvVarFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "EnvVarField",
    component: EnvVarField,
    validation: envVarValidation,
  })
);
